import { Menu, Tooltip } from '@mantine/core';
import { IconClipboardCheck } from '@tabler/icons-react';
import classnames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import useIsMobile from 'src/Hooks/Shared/useIsMobile';
import useOverdueTaskCount from 'src/Hooks/Shared/useOverdueTaskCount';

import styles from './TasksMenu.module.scss';
import { TasksPopup } from './TasksPopup';

const TasksMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const assetId = useCurrentAssetId();
  const isMobile = useIsMobile();
  const [opened, setOpened] = useState(false);
  const { overdueCount, isLoading } = useOverdueTaskCount();

  const tooltipText =
    overdueCount > 0
      ? t('tasks.badge.overdue', '{{count}} tâches en retard', { count: overdueCount })
      : t('tasks.badge.noTasks', 'Tâches');

  const goToTasks = () => {
    setOpened(false);
    if (assetId) navigate(`/asset/${assetId}/tasks`);
  };

  const badge = overdueCount > 0 && (
    <div className={styles.badge}>{overdueCount > 99 ? '99+' : overdueCount}</div>
  );

  const iconWithBadge = (
    <div className={styles.iconWrapper}>
      <IconClipboardCheck size={22} />
      {badge}
    </div>
  );

  const label = <span className={styles.label}>{t('tasks.badge.noTasks', 'Tâches')}</span>;

  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.iconButton}>
          {iconWithBadge}
          {!isMobile && label}
        </div>
      </div>
    );
  }

  if (isMobile) {
    return (
      <div className={styles.container}>
        <div className={styles.iconButton} onClick={goToTasks}>
          {iconWithBadge}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Menu opened={opened} onChange={setOpened} trigger="hover" width={420} position="bottom-end">
        <Menu.Target>
          <Tooltip label={tooltipText} disabled={opened}>
            <div
              className={classnames(styles.iconButton, { [styles.iconButtonActive]: opened })}
              onClick={goToTasks}
            >
              {iconWithBadge}
              {label}
            </div>
          </Tooltip>
        </Menu.Target>
        <Menu.Dropdown>
          <TasksPopup onClose={() => setOpened(false)} />
        </Menu.Dropdown>
      </Menu>
    </div>
  );
};

export default TasksMenu;
